import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { renderLinkedText } from "@/lib/content";

export const Manifesto = () => {
  const { content } = useContent();
  const m = content.manifesto;
  return (
  <section
    id="promise"
    className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40"
    data-testid="manifesto-section"
  >
    <div className="grid gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:sticky lg:top-32"
        >
          <p className="mb-6 text-[11px] font-bold uppercase tracking-[0.3em] text-[#7A2B21]">
            {m.kicker}
          </p>
          <h2 className="font-display text-4xl font-medium leading-[1.1] tracking-tight text-[#1C1917] sm:text-5xl">
            {m.title_line1}
            <br />
            <span className="italic text-[#7A2B21]">{m.title_line2}</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#57534E]">
            {m.intro}
          </p>
        </motion.div>
      </div>

      <div className="space-y-0 lg:col-span-7">
        {m.chapters.map((c, i) => (
          <motion.article
            key={c.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group flex gap-8 border-t border-[#1C1917]/10 py-12 first:border-t-0 lg:gap-14"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <span className="font-display text-5xl font-light text-[#C5A059] transition-colors duration-500 group-hover:text-[#7A2B21] lg:text-7xl">
              {c.num}
            </span>
            <div>
              <h3 className="font-display text-2xl font-medium tracking-tight text-[#1C1917] md:text-3xl">
                {renderLinkedText(c.title)}
              </h3>
              <p className="mt-4 max-w-lg text-base leading-relaxed text-[#57534E]">
                {renderLinkedText(c.body)}
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
  );
};
